/**
 * Static "What's new" feed shown on /welcome, newest first.
 * Drafted before each deploy by the `whats-new` agent skill (agent/skills/whats-new).
 */
export interface WhatsNewEntry {
  /** Deploy date, YYYY-MM-DD. */
  date: string;
  title: string;
  items: string[];
}

export const WHATS_NEW: WhatsNewEntry[] = [
  {
    date: '2026-10-10',
    title: 'CI Runners: ดูเครื่อง self-hosted runner, คิวงาน และประวัติ job',
    items: [
      'เมนูใหม่ CI Runners มีหน้า Overview, Machines, Runners, Job Queue และ History (ดูได้อย่างเดียว ไม่มีปุ่มสั่งงาน runner)',
      'Machines: CPU, RAM, Swap, Disk แยก volume, Disk I/O และ Network ของแต่ละเครื่อง พร้อมกราฟย้อนหลัง 1 ชั่วโมง / 24 ชั่วโมง / 7 วัน',
      'เครื่องที่ไม่ส่ง heartbeat เกิน 60 วินาทีจะขึ้น Offline และบอกว่าข้อมูลที่เห็นเป็นข้อมูลเก่า',
      'Job Queue แยกงานที่รอ runner ออกจากงานที่รอ approval, job อื่น หรือ concurrency และแสดง runner ที่ label ตรงกัน',
      'History แสดง timeline ของแต่ละ runner พร้อมลิงก์ไป job และ logs บน GitHub และกราฟทรัพยากรเครื่องในช่วงเวลาของ job นั้น',
      'หน้าจออัปเดตเองโดยไม่ต้อง reload และแสดงเวลาเป็นเวลาไทยเมื่อ timezone ตั้งเป็น Auto',
    ],
  },
  {
    date: '2026-10-08',
    title: 'หน้า error โฉมใหม่ และปรับหน้า Desktop Updates',
    items: [
      'หน้า error ทุกหน้ามีภาพเคลื่อนไหวชุดใหม่ และเปลี่ยนข้อความเป็นภาษาอังกฤษทั้งหมด',
      'โหลดข้อมูลบัญชีไม่สำเร็จ: ปลั๊กหลุดพร้อมประกายไฟ กด Try again แล้วปลั๊กจะต่อกลับระหว่างโหลด',
      'หน้า Access denied (403): แม่กุญแจล็อกลงมาพร้อมประกายไฟ',
      'บัญชีที่ยังไม่ได้รับสิทธิ์หรือถูกระงับ: บัตรโดนประทับตรา DENIED / DISABLED',
      'หน้า 404: ขนาดใหญ่ขึ้น และเลข 404 เองก็หาไม่เจอเหมือนกัน',
      'ถ้าหน้าไหนพังระหว่างใช้งาน จะขึ้นหน้า Something went wrong พร้อมปุ่ม Reload page แทนจอขาว',
      'Release → Desktop Updates: URL แต่ละรายการมีปุ่ม copy URL ยาวจะเลื่อนให้ดูเอง เอาเมาส์วางเพื่อหยุด, Latest downloads แสดงทันที และเปิดดู manifest ใน modal ขนาดใหญ่',
    ],
  },
  {
    date: '2026-10-02',
    title: 'แจ้งเตือน build ผ่าน Slack และหน้า Home ใหม่',
    items: [
      "หน้า Home ใหม่ — หลัง login จะมาที่หน้านี้ พร้อม What's new สรุปสิ่งที่อัปเดตในแต่ละรอบ",
      'เชื่อมบัญชี Slack ได้ที่ Personal settings → Connect Slack เพื่อรับ DM เมื่อ build เริ่ม สำเร็จ ล้มเหลว หรือ publish',
      'กด Watch ที่หน้า release เพื่อรับแจ้งเตือนของ release นั้นทาง Slack',
      'ตั้ง Slack channel แยกตาม environment ได้ที่ Release → Products พร้อมปุ่ม Send test',
      'ย้าย Apple UDID และ Other emails ไปอยู่ในหน้า Personal settings (/profile/settings)',
    ],
  },
];
